import token, { tokenToVars } from '../token';
import Icon from './icon';

export { Icon };
export default tokenToVars(Icon, token);
